import { GetExtranetCustomerGroupQueryDto } from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../../features/infinite-query/util/cleanQueryParams'

export type GroupSettingFilters = {
  scheduleSlotId: number
  scheduleSlotNotSet: boolean
  productId: number
  productNotSet: boolean
  active: boolean
  passive: boolean
}

export const mapCustomerGroupSearchParamsToQueryParams = (
  searchParams: URLSearchParams
): GetExtranetCustomerGroupQueryDto & GroupSettingFilters => {
  const parsedParams = {
    groupName: searchParams.get('groupName') ?? undefined,
    scheduleSlotId:
      searchParams.getAll('scheduleSlotId').length > 0
        ? searchParams.getAll('scheduleSlotId').map(Number)
        : undefined,
    productId:
      searchParams.getAll('productId').length > 0
        ? searchParams.getAll('productId').map(Number)
        : undefined,
    active: (searchParams.get('active') && searchParams.get('active') === 'true') ?? undefined,
    passive: (searchParams.get('passive') && searchParams.get('passive') === 'true') ?? undefined,
    scheduleSlotNotSet:
      (searchParams.get('scheduleSlotNotSet') &&
        searchParams.get('scheduleSlotNotSet') === 'true') ??
      undefined,
    productNotSet:
      (searchParams.get('productNotSet') && searchParams.get('productNotSet') === 'true') ??
      undefined,
  }

  return cleanQueryParams(parsedParams)
}
